import { FormattedMessage } from 'react-intl';
import BarChartIcon from '@mui/icons-material/BarChart';
import { PERMISSION_LIST } from 'config';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

// const CompetitiveIcon = () => (
//   <img src={competitive_icon} alt="Compeptitive landscape" style={{ width: '18', height: '18', border: 'black' }} />
// );
const CompetitiveIcon = () => <BarChartIcon />;

const CptIcon = () => (
  <svg width={18} height={18} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11H27V9H8V11ZM23 16H27V14H8V16H23ZM16.0709 24C16.1719 24.7061 16.3783 25.3783 16.6736 26H8V24H16.0709ZM17.2547 19C16.8334 19.604 16.5049 20.2776 16.2899 21H8V19H17.2547Z"
      fill="white"
    />
    <rect x="1.5" y="1.5" width="32" height="32" rx="3.5" stroke="white" strokeWidth="3" />
    <circle cx="24" cy="23" r="6" fill="white" />
    <path d="M24 20L26.5981 24.5H21.4019L24 20Z" fill="#3D2260" />
  </svg>
);

const ProfessionalIcon = () => (
  <svg width={18} height={18} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="3" fill="white" stroke="white" strokeWidth="3" />
    <path
      d="M13.297 14.98C13.297 15.6733 13.117 16.3267 12.757 16.94C12.4104 17.54 11.8904 18.04 11.197 18.44C10.517 18.8267 9.71036 19.0533 8.77703 19.12V20.74H7.49703V19.1C6.1637 18.98 5.09036 18.58 4.27703 17.9C3.4637 17.2067 3.0437 16.2733 3.01703 15.1H6.01703C6.09703 16.06 6.59036 16.64 7.49703 16.84V13.02C6.53703 12.78 5.7637 12.54 5.17703 12.3C4.59036 12.06 4.0837 11.6733 3.65703 11.14C3.23036 10.6067 3.01703 9.88 3.01703 8.96C3.01703 7.8 3.43036 6.85333 4.25703 6.12C5.09703 5.38667 6.17703 4.96667 7.49703 4.86V3.24H8.77703V4.86C10.057 4.96667 11.077 5.35333 11.837 6.02C12.6104 6.68667 13.0437 7.60667 13.137 8.78H10.117C10.077 8.39333 9.93703 8.06 9.69703 7.78C9.47036 7.48667 9.1637 7.28 8.77703 7.16V10.94C9.77703 11.1933 10.5637 11.44 11.137 11.68C11.7237 11.9067 12.2304 12.2867 12.657 12.82C13.0837 13.34 13.297 14.06 13.297 14.98ZM5.93703 8.82C5.93703 9.26 6.07036 9.62 6.33703 9.9C6.6037 10.1667 6.99036 10.3867 7.49703 10.56V7.1C7.01703 7.16667 6.63703 7.34667 6.35703 7.64C6.07703 7.93333 5.93703 8.32667 5.93703 8.82ZM8.77703 16.88C9.2837 16.7867 9.67703 16.58 9.95703 16.26C10.2504 15.94 10.397 15.5533 10.397 15.1C10.397 14.66 10.257 14.3067 9.97703 14.04C9.69703 13.7733 9.29703 13.5533 8.77703 13.38V16.88Z"
      fill="#3C265F"
    />
    <path
      d="M29.297 26.98C29.297 27.6733 29.117 28.3267 28.757 28.94C28.4104 29.54 27.8904 30.04 27.197 30.44C26.517 30.8267 25.7104 31.0533 24.777 31.12V32.74H23.497V31.1C22.1637 30.98 21.0904 30.58 20.277 29.9C19.4637 29.2067 19.0437 28.2733 19.017 27.1H22.017C22.097 28.06 22.5904 28.64 23.497 28.84V25.02C22.537 24.78 21.7637 24.54 21.177 24.3C20.5904 24.06 20.0837 23.6733 19.657 23.14C19.2304 22.6067 19.017 21.88 19.017 20.96C19.017 19.8 19.4304 18.8533 20.257 18.12C21.097 17.3867 22.177 16.9667 23.497 16.86V15.24H24.777V16.86C26.057 16.9667 27.077 17.3533 27.837 18.02C28.6104 18.6867 29.0437 19.6067 29.137 20.78H26.117C26.077 20.3933 25.937 20.06 25.697 19.78C25.4704 19.4867 25.1637 19.28 24.777 19.16V22.94C25.777 23.1933 26.5637 23.44 27.137 23.68C27.7237 23.9067 28.2304 24.2867 28.657 24.82C29.0837 25.34 29.297 26.06 29.297 26.98ZM21.937 20.82C21.937 21.26 22.0704 21.62 22.337 21.9C22.6037 22.1667 22.9904 22.3867 23.497 22.56V19.1C23.017 19.1667 22.637 19.3467 22.357 19.64C22.077 19.9333 21.937 20.3267 21.937 20.82ZM24.777 28.88C25.2837 28.7867 25.677 28.58 25.957 28.26C26.2504 27.94 26.397 27.5533 26.397 27.1C26.397 26.66 26.257 26.3067 25.977 26.04C25.697 25.7733 25.297 25.5533 24.777 25.38V28.88Z"
      fill="#3C265F"
    />
    <line x1="22.1547" y1="9.36969" x2="10.5411" y2="25.131" stroke="#3C265F" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const TaxIdIcon = () => (
  <svg width={18} height={18} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="35" height="35" rx="3" fill="white" stroke="white" strokeWidth="3" />
    <rect x="9" y="9" width="13" height="26" fill="#3C265F" />
    <rect x="15" y="12" width="1" height="5" fill="white" />
    <rect x="13" y="14" width="5" height="1" fill="white" />
    <mask id="path-5-inside-1_487_384" fill="white">
      <path d="M17 20H26V35H17V20Z" />
    </mask>
    <path d="M17 20H26V35H17V20Z" fill="#3C265F" />
    <path d="M17 20V19.8H16.8V20H17ZM17 20.2H26V19.8H17V20.2ZM17.2 35V20H16.8V35H17.2Z" fill="white" mask="url(#path-5-inside-1_487_384)" />
    <rect x="19" y="22" width="5" height="3" fill="white" />
    <rect x="19" y="27" width="5" height="3" fill="white" />
    <rect x="19" y="32" width="5" height="3" fill="white" />
    <rect x="13" y="22" width="4" height="3" fill="white" />
    <rect x="13" y="27" width="4" height="3" fill="white" />
    <rect x="13" y="32" width="4" height="3" fill="white" />
  </svg>
);

// const ReportIcon = () => {
//   <svg width={18} height={18} viewBox="0 0 42 35" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M4.07661 25.25L17.5 2L30.9234 25.25H4.07661Z" fill="#3C265F" stroke="white" strokeWidth="2" />
//     <path d="M11.0048 21.25L17.5 10L23.9952 21.25H11.0048Z" fill="white" stroke="white" strokeWidth="2" />
//     <circle cx="32" cy="24" r="9" fill="white" stroke="#3C265F" strokeWidth="2" />
//     <path
//       d="M29.5508 25.8789V21.9297C29.5508 21.4766 29.7188 21.0352 30.0547 20.6055C30.5 20.0352 31.1016 19.7461 31.8594 19.7383V21.3906C31.5312 21.3984 31.3203 21.5508 31.2266 21.8477C31.2109 21.8789 31.2031 21.9062 31.2031 21.9297V25.8789C31.2031 26.0039 31.2695 26.125 31.4023 26.2422C31.5273 26.3516 31.6797 26.4062 31.8594 26.4062V28.0586C30.9844 28.0586 30.3242 27.6914 29.8789 26.957C29.6602 26.582 29.5508 26.2227 29.5508 25.8789ZM32.4922 28.0586V26.4062C32.4922 26.4062 32.582 26.3711 32.7617 26.3008C32.8711 26.2227 32.9453 26.1406 32.9844 26.0547C33.0234 25.9531 33.043 25.8086 33.043 25.6211V25.4805L34.6602 25.8672C34.6602 26.5469 34.3867 27.1094 33.8398 27.5547C33.4258 27.8906 32.9766 28.0586 32.4922 28.0586ZM32.4922 21.3906V19.7383C33.0625 19.7383 33.5781 19.9883 34.0391 20.4883C34.4531 20.9414 34.6602 21.4297 34.6602 21.9531L33.043 22.375V22.1992C33.043 22.0039 33.0234 21.8594 32.9844 21.7656C32.9531 21.6875 32.8945 21.6172 32.8086 21.5547C32.7305 21.4922 32.6602 21.4492 32.5977 21.4258L32.4922 21.3906Z"
//       fill="#3C265F"
//     />
//   </svg>
// };

const professional = (permissions) => {
  const hasCompetitiveLandscapePermission = permissions[PERMISSION_LIST.COMPETITIVE_LANDSCAPE];
  const hasTopCptPermission = permissions[PERMISSION_LIST.TOP_CPTS_OVERVIEW];
  const hasRateViewPermission = permissions[PERMISSION_LIST.PROFESSIONAL_RATE_VIEW];
  const hasRateUtilizationViewPermission = permissions[PERMISSION_LIST.PROFESSIONAL_RATE_UTILIZATION_VIEW];
  const hasRateViewByTinPermission = permissions[PERMISSION_LIST.PROFESSIONAL_RATE_VIEW_BY_TIN];
  const hasRateUtilizationViewByTinPermission = permissions[PERMISSION_LIST.PROFESSIONAL_RATE_UTILIZATION_VIEW_BY_TIN];
  const hasRateInsightsPermission = permissions[PERMISSION_LIST.PROVIDER_TAX_ID_INSIGHTS];
  const hasHistoricalRequestPermission = permissions[PERMISSION_LIST.HISTORICAL_REQUESTS];

  const children = [];

  if (hasCompetitiveLandscapePermission) {
    children.push({
      id: 'competitive-landscape',
      title: <FormattedMessage id="competitive-landscape" />,
      type: 'item',
      url: '/',
      icon: CompetitiveIcon,
      hasNew: {
        professional: '/v1/'
      }
    });
  }
  if (hasTopCptPermission) {
    children.push({
      id: 'top-cpts-overview',
      title: <FormattedMessage id="top-cpts-overview" />,
      type: 'item',
      url: '/top-cpt',
      icon: CptIcon,
      hasNew: {
        professional: '/v1/topCpt'
      }
    });
  }
  if (hasRateViewPermission) {
    children.push({
      id: 'professional-rate-view',
      title: <FormattedMessage id="professional-rate-view" />,
      type: 'item',
      url: '/professional-rate-view',
      icon: ProfessionalIcon,
      hasNew: {
        professional: '/v1/Ratechoiceview'
      }
    });
  }
  if (hasRateUtilizationViewPermission) {
    children.push({
      id: 'professional-rate-utilization-view',
      title: <FormattedMessage id="professional-rate-utilization-view" />,
      type: 'item',
      url: '/professional-rate-utilization-view',
      icon: ProfessionalIcon,
      hasNew: {
        professional: '/v1/ProfessionalRateUtilizationview'
      }
    });
  }
  if (hasRateViewByTinPermission) {
    children.push({
      id: 'professional-rate-view-by-tin',
      title: <FormattedMessage id="professional-rate-view-by-tin" />,
      type: 'item',
      url: '/professional-rate-view-by-tin',
      icon: ProfessionalIcon,
      hasNew: {
        professional: '/v1/RatechoiceviewByTIN'
      }
    });
  }
  if (hasRateUtilizationViewByTinPermission) {
    children.push({
      id: 'professional-rate-utilization-view-by-tin',
      title: <FormattedMessage id="professional-rate-utilization-view-by-tin" />,
      type: 'item',
      url: '/professional-rate-utilization-view-by-tin',
      icon: ProfessionalIcon,
      hasNew: {
        professional: '/v1/ProfessionalRateUtilizationviewByTIN'
      }
    });
  }
  if (hasRateInsightsPermission) {
    children.push({
      id: 'provider-rate-insights',
      title: <FormattedMessage id="provider-rate-insights" />,
      type: 'item',
      url: '/rate-insights',
      icon: TaxIdIcon,
      hasNew: {
        professional: '/v1/RateInsightsByTIN'
      }
    });
  }
  if (hasHistoricalRequestPermission) {
    children.push({
      id: 'historical-requests',
      title: <FormattedMessage id="historical-requests" />,
      type: 'item',
      url: '/historical-requests',
      icon: CptIcon,
      hasNew: {
        professional: '/v1/historicalrequests'
      }
    });
  }

  return {
    id: 'professional',
    type: 'group',
    children
  };
};

const dataAuditReport = (allDataAuditReportPermission) => {
  const hasViewPayerScorecardPermission = allDataAuditReportPermission[PERMISSION_LIST.PAYER_SCORECARD];
  const hasViewReportSummaryPermission = allDataAuditReportPermission[PERMISSION_LIST.REPORT_SUMMARY];
  const hasViewProcedureCostByHospitalPermission = allDataAuditReportPermission[PERMISSION_LIST.PROCEDURE_COST_BY_HOSPITAL];
  const hasViewDrgCountPermission = allDataAuditReportPermission[PERMISSION_LIST.DRG_COUNTS_BY_PAYER_AND_HOSPITAL];
  const children = [];
  if (hasViewPayerScorecardPermission) {
    children.push({
      id: 'payer-scorecard',
      title: <FormattedMessage id="payer-scorecard" />,
      type: 'item',
      url: '/payer-scorecard',
      icon: CptIcon
    });
  }
  if (hasViewReportSummaryPermission) {
    children.push({
      id: 'report-summary',
      title: <FormattedMessage id="report-summary" />,
      type: 'item',
      url: '/report-summary',
      icon: CptIcon
    });
  }
  if (hasViewProcedureCostByHospitalPermission) {
    children.push({
      id: 'procedure-cost-by-hospital',
      title: <FormattedMessage id="procedure-cost-by-hospital" />,
      type: 'item',
      url: '/procedure-cost-by-hospital',
      icon: ProfessionalIcon
    });
  }
  if (hasViewDrgCountPermission) {
    children.push({
      id: 'drg-counts-by-payer-&-hospital',
      title: <FormattedMessage id="drg-counts-by-payer-&-hospital" />,
      type: 'item',
      url: '/drg-ref-table',
      icon: ProfessionalIcon
    });
  }
  return {
    id: 'dataAuditReport',
    type: 'group',
    children
  };
};

const facility = (allFacilityPermission) => {
  const hasCompetitiveLandscapePermission = allFacilityPermission[PERMISSION_LIST.COMPETITIVE_LANDSCAPE];
  const hasTopDrgsOverviewPermission = allFacilityPermission[PERMISSION_LIST.TOP_DRGS_OVERVIEW];
  const hasTopCptOverviewPermission = allFacilityPermission[PERMISSION_LIST.TOP_CPTS_OVERVIEW];
  const hasPayerPriceComparisonCptHcpcsPermission = allFacilityPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS];
  const hasPayerPriceComparisonDrgPermission = allFacilityPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG];
  const hasPayerPriceComparisonApcPermission = allFacilityPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC];
  const hasFilteredDrgListPermission = allFacilityPermission[PERMISSION_LIST.FILTERED_DRG_LIST];
  const hasProviderCptHcpcsDataPermission = allFacilityPermission[PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA];
  const hasHistoricalRequestPermission = allFacilityPermission[PERMISSION_LIST.HISTORICAL_REQUESTS];
  const hasFacilityScorecardPermission = allFacilityPermission[PERMISSION_LIST.FACILITY_SCORECARD];

  const children = [];

  if (hasCompetitiveLandscapePermission) {
    children.push({
      id: 'competitive-landscape',
      title: <FormattedMessage id="competitive-landscape" />,
      type: 'item',
      url: '/',
      icon: CompetitiveIcon
    });
  }
  if (hasTopDrgsOverviewPermission) {
    children.push({
      id: 'top-drgs-overview',
      title: <FormattedMessage id="top-drgs-overview" />,
      type: 'item',
      url: '/top-drg',
      icon: CptIcon
    });
  }
  if (hasTopCptOverviewPermission) {
    children.push({
      id: 'top-cpts-overview',
      title: <FormattedMessage id="top-cpts-overview" />,
      type: 'item',
      url: '/top-cpt',
      icon: CptIcon
    });
  }
  if (hasPayerPriceComparisonCptHcpcsPermission) {
    children.push({
      id: 'payer-price-comparison-CPT,-HCPCS',
      title: <FormattedMessage id="payer-price-comparison-CPT,-HCPCS" />,
      type: 'item',
      url: '/payer-price-comparison-CPT-HCPCS',
      icon: ProfessionalIcon,
      filterType: ['CPT', 'HCPCS']
    });
  }
  if (hasPayerPriceComparisonDrgPermission) {
    children.push({
      id: 'payer-price-comparison-DRG',
      title: <FormattedMessage id="payer-price-comparison-DRG" />,
      type: 'item',
      url: '/payers-price-compare-drg',
      icon: ProfessionalIcon,
      filterType: ['DRG'],
      hideModifier: true
    });
  }
  if (hasPayerPriceComparisonApcPermission) {
    children.push({
      id: 'payer-price-comparison-APC',
      title: <FormattedMessage id="payer-price-comparison-APC" />,
      type: 'item',
      url: '/payers-price-compare-apc',
      icon: ProfessionalIcon,
      filterType: ['APC']
    });
  }
  if (hasFilteredDrgListPermission) {
    children.push({
      id: 'filtered-drg-list',
      title: <FormattedMessage id="filtered-drg-list" />,
      type: 'item',
      url: '/filtered-drg-list',
      icon: CptIcon
    });
  }
  if (hasProviderCptHcpcsDataPermission) {
    children.push({
      id: 'provider-CPT-HCPCS-data',
      title: <FormattedMessage id="provider-CPT-HCPCS-data" />,
      type: 'item',
      url: '/provider-CPT-HCPCS-data',
      filterType: ['CPT'],
      icon: CptIcon
    });
  }
  if (hasHistoricalRequestPermission) {
    children.push({
      id: 'historical-requests',
      title: <FormattedMessage id="historical-requests" />,
      type: 'item',
      url: '/historical-requests',
      icon: CptIcon
    });
  }
  if (hasFacilityScorecardPermission) {
    children.push({
      id: 'facility-scorecard',
      title: <FormattedMessage id="facility-scorecard" />,
      type: 'item',
      url: '/facility-scorecard',
      icon: CptIcon
    });
  }

  return {
    id: 'facility',
    type: 'group',
    children
  };
};

const ancillary = (allAncillaryPermission) => {
  const hasCompetitiveLandscapePermission = allAncillaryPermission[PERMISSION_LIST.COMPETITIVE_LANDSCAPE];
  const hasTopDrgsOverviewPermission = allAncillaryPermission[PERMISSION_LIST.TOP_DRGS_OVERVIEW];
  const hasTopCptOverviewPermission = allAncillaryPermission[PERMISSION_LIST.TOP_CPTS_OVERVIEW];
  const hasPayerPriceComparisonCptHcpcsPermission = allAncillaryPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS];
  const hasPayerPriceComparisonDrgPermission = allAncillaryPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG];
  const hasPayerPriceComparisonApcPermission = allAncillaryPermission[PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC];
  const hasFilteredDrgListPermission = allAncillaryPermission[PERMISSION_LIST.FILTERED_DRG_LIST];
  const hasProviderCptHcpcsDataPermission = allAncillaryPermission[PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA];
  const hasHistoricalRequestPermission = allAncillaryPermission[PERMISSION_LIST.HISTORICAL_REQUESTS];
  const hasFacilityScorecardPermission = allAncillaryPermission[PERMISSION_LIST.FACILITY_SCORECARD];

  const children = [];

  if (hasCompetitiveLandscapePermission) {
    children.push({
      id: 'competitive-landscape',
      title: <FormattedMessage id="competitive-landscape" />,
      type: 'item',
      url: '/',
      icon: CompetitiveIcon
    });
  }
  if (hasTopDrgsOverviewPermission) {
    children.push({
      id: 'top-drgs-overview',
      title: <FormattedMessage id="top-drgs-overview" />,
      type: 'item',
      url: '/top-drg',
      icon: CptIcon
    });
  }
  if (hasTopCptOverviewPermission) {
    children.push({
      id: 'top-cpts-overview',
      title: <FormattedMessage id="top-cpts-overview" />,
      type: 'item',
      url: '/top-cpt',
      icon: CptIcon
    });
  }
  if (hasPayerPriceComparisonCptHcpcsPermission) {
    children.push({
      id: 'payer-price-comparison-CPT,-HCPCS',
      title: <FormattedMessage id="payer-price-comparison-CPT,-HCPCS" />,
      type: 'item',
      url: '/payer-price-comparison-CPT-HCPCS',
      icon: ProfessionalIcon,
      filterType: ['CPT', 'HCPCS']
    });
  }
  if (hasPayerPriceComparisonDrgPermission) {
    children.push({
      id: 'payer-price-comparison-DRG',
      title: <FormattedMessage id="payer-price-comparison-DRG" />,
      type: 'item',
      url: '/payers-price-compare-drg',
      icon: ProfessionalIcon,
      filterType: ['DRG'],
      hideModifier: true
    });
  }
  if (hasPayerPriceComparisonApcPermission) {
    children.push({
      id: 'payer-price-comparison-APC',
      title: <FormattedMessage id="payer-price-comparison-APC" />,
      type: 'item',
      url: '/payers-price-compare-apc',
      icon: ProfessionalIcon,
      filterType: ['APC']
    });
  }
  if (hasFilteredDrgListPermission) {
    children.push({
      id: 'filtered-drg-list',
      title: <FormattedMessage id="filtered-drg-list" />,
      type: 'item',
      url: '/filtered-drg-list',
      icon: CptIcon
    });
  }
  if (hasProviderCptHcpcsDataPermission) {
    children.push({
      id: 'provider-CPT-HCPCS-data',
      title: <FormattedMessage id="provider-CPT-HCPCS-data" />,
      type: 'item',
      url: '/provider-CPT-HCPCS-data',
      filterType: ['CPT'],
      icon: CptIcon
    });
  }
  if (hasHistoricalRequestPermission) {
    children.push({
      id: 'historical-requests',
      title: <FormattedMessage id="historical-requests" />,
      type: 'item',
      url: '/historical-requests',
      icon: CptIcon
    });
  }
  if (hasFacilityScorecardPermission) {
    children.push({
      id: 'facility-scorecard',
      title: <FormattedMessage id="facility-scorecard" />,
      type: 'item',
      url: '/facility-scorecard',
      icon: CptIcon
    });
  }

  return {
    id: 'ancillary',
    type: 'group',
    children
  };
};

export { professional, dataAuditReport, facility, ancillary };
